import React from 'react';
import image from '../../../../public/preloader.png';
import NextImage from '@/features/Image';

const Preloader = () => {
  return (
    <div className="preloader mt-0">
      <NextImage
        width={100}
        height={100}
        src={image.src}
        alt="preloader icon"
      />
    </div>
  );
};

export default Preloader;
